import type { HCWCategory } from '@/types';

export const HCW_CATEGORIES: HCWCategory[] = [
  // Nurse / Midwife
  {
    code: '1.1',
    name: 'Nurse',
    name_en: 'Nurse',
    name_es: 'Enfermera',
    parentCategory: 'nurse_midwife',
    sortOrder: 1,
    active: true,
  },
  {
    code: '1.2',
    name: 'Midwife',
    name_en: 'Midwife',
    name_es: 'Partera',
    parentCategory: 'nurse_midwife',
    sortOrder: 2,
    active: true,
  },
  {
    code: '1.3',
    name: 'Student Nurse',
    name_en: 'Student Nurse',
    name_es: 'Estudiante de Enfermería',
    parentCategory: 'nurse_midwife',
    sortOrder: 3,
    active: true,
  },
  // Auxiliary / Support
  {
    code: '2.1',
    name: 'Nursing Auxiliary',
    name_en: 'Nursing Auxiliary',
    name_es: 'Auxiliar de Enfermería',
    parentCategory: 'auxiliary',
    sortOrder: 4,
    active: true,
  },
  {
    code: '2.2',
    name: 'Patient Care Assistant',
    name_en: 'Patient Care Assistant',
    name_es: 'Asistente de Cuidado al Paciente',
    parentCategory: 'auxiliary',
    sortOrder: 5,
    active: true,
  },
  // Medical Doctor
  {
    code: '3.1',
    name: 'Doctor (Internal Medicine)',
    name_en: 'Doctor (Internal Medicine)',
    name_es: 'Médico (Medicina Interna)',
    parentCategory: 'medical_doctor',
    sortOrder: 6,
    active: true,
  },
  {
    code: '3.2',
    name: 'Surgeon',
    name_en: 'Surgeon',
    name_es: 'Cirujano',
    parentCategory: 'medical_doctor',
    sortOrder: 7,
    active: true,
  },
  {
    code: '3.3',
    name: 'Anesthetist',
    name_en: 'Anesthetist',
    name_es: 'Anestesiólogo',
    parentCategory: 'medical_doctor',
    sortOrder: 8,
    active: true,
  },
  {
    code: '3.4',
    name: 'Pediatrician',
    name_en: 'Pediatrician',
    name_es: 'Pediatra',
    parentCategory: 'medical_doctor',
    sortOrder: 9,
    active: true,
  },
  {
    code: '3.5',
    name: 'Gynecologist',
    name_en: 'Gynecologist',
    name_es: 'Ginecólogo',
    parentCategory: 'medical_doctor',
    sortOrder: 10,
    active: true,
  },
  {
    code: '3.6',
    name: 'Consultant',
    name_en: 'Consultant',
    name_es: 'Consultor',
    parentCategory: 'medical_doctor',
    sortOrder: 11,
    active: true,
  },
  {
    code: '3.7',
    name: 'Medical Student',
    name_en: 'Medical Student',
    name_es: 'Estudiante de Medicina',
    parentCategory: 'medical_doctor',
    sortOrder: 12,
    active: true,
  },
  {
    code: '3.8',
    name: 'Medical Resident',
    name_en: 'Medical Resident',
    name_es: 'Residente Médico',
    parentCategory: 'medical_doctor',
    sortOrder: 13,
    active: true,
  },
  // Allied Health
  {
    code: '4.1',
    name: 'Therapist',
    name_en: 'Therapist',
    name_es: 'Terapeuta',
    parentCategory: 'allied_health',
    sortOrder: 11,
    active: true,
  },
  {
    code: '4.2',
    name: 'Technician',
    name_en: 'Technician',
    name_es: 'Técnico',
    parentCategory: 'allied_health',
    sortOrder: 12,
    active: true,
  },
  {
    code: '4.3',
    name: 'Dietician',
    name_en: 'Dietician',
    name_es: 'Nutricionista',
    parentCategory: 'allied_health',
    sortOrder: 13,
    active: true,
  },
  // Other
  {
    code: '5.1',
    name: 'Other HCW',
    name_en: 'Other HCW',
    name_es: 'Otro Trabajador de Salud',
    parentCategory: 'other',
    sortOrder: 14,
    active: true,
  },
];
